import withRouter from "../../withRouter";
import NavBar from "../../components/navbar";
import MonthlySalesChartPage from "./chart/monthlyChart/MonthlySalesChartPage";
import AverageSalesDayPage from "./chart/averageSalesDay/AverageSalesDayPage";
import AverageSalesTimePage from "./chart/averageSalesTime/AverageSalesTimePage";
import TotalSalesDayPage from "./chart/totalSalesDay/TotalSalesDayPage";
import GrossSalesBreakdownPage from "./chart/grossSalesBreakdown/GrossSalesBreakdownPage";
import BaseListPage from "../../base/BaseListPage";
import GrossSalesPresenter from "./GrossSalesPresenter";
import { countObjectUseCase, findObjectUseCase } from "../../usecases/object";
import TotalSalesWeekDayPage from "./chart/totalSalesWeekDay/TotalSalesWeekDayPage";
import ProgressLoader from "../../components/ProgressLoader";
import TargetHit from "../sales-and-transactions/chart/targetHit/TargetHit";

class GrossSalesPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new GrossSalesPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
    );
    this.state = {
      store: [],
      storess: "",
    };
  }
  getCollectionName() {
    return "transactions";
  }
  onChangeDate(where) {
    console.log("Where", where);
    const gteDate = new Date(where["$gte"]);
    const lteDate = new Date(where["$lte"]);

    gteDate.setUTCHours(5, 0, 0, 0);
    lteDate.setUTCDate(lteDate.getUTCDate());
    lteDate.setUTCHours(4, 59, 59, 999);

    where["$gte"] = gteDate.toISOString();
    where["$lte"] = lteDate.toISOString();

    this.presenter.onChangeDate(where);
  }

  onChangeStore(where) {
    this.presenter.onChangeStore(where);
    this.setState({ storess: where });
  }

  setStore(store) {
    this.setState({ store });
  }

  getProgressPercentage() {
    const { objects, count } = this.state;
    if (!count || count === 0) return 0;
    return Math.min(Math.round((objects.length / count) * 100), 100);
  }

  setNotFound(notFound) {
    this.setState({ notFound });
  }

  render() {
    const objects = this.state.objects || [];
    console.log("objects", objects);

    const store = this.state.store;

    console.log("SSS", store);
    return (
      <>
        <NavBar />
        <div className="overflow-auto">
          <div className="p-3 p-lg-4">
            <div className="d-flex justify-content-between align-items-center">
              <h1
                className="fw-bold mt-1 text-capitalize"
                style={{ color: "#83c14a" }}
              >
                Gross Sales
              </h1>
            </div>
            <ProgressLoader
              loaded={this.state.objects?.length}
              total={this.state.count}
              getProgressPercentage={() => this.getProgressPercentage()}
            />
            <MonthlySalesChartPage
              objects={objects}
              onChangeDate={this.onChangeDate.bind(this)}
              onChangeStore={this.onChangeStore.bind(this)}
              dateField="createdAt"
              store={store}
              storess={this.state.storess}
              progress={this.presenter.progress}
              notFound={this.state.notFound}
            />
            <div className="mt-4">
              <TargetHit
                objects={objects}
                storess={this.state.storess}
                store={store}
              />
            </div>

            {/* <AverageSalesDayPage
              objects={objects}
              onChangeDate={this.onChangeDate.bind(this)}
              onChangeStore={this.onChangeStore.bind(this)}
              dateField="createdAt"
              store={store}
              storess={this.state.storess}
            /> */}

            <TotalSalesWeekDayPage />

            <AverageSalesTimePage objects={objects} />

            <TotalSalesDayPage objects={objects} />

            {/* <GrossSalesBreakdownPage objects={objects} /> */}
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(GrossSalesPage);
